export function getPremiumPricesByCountry(countryId) {
  const isUS = String(countryId) === "2";

  if (isUS) {
    return {
      isUS: true,
      currencyCode: "USD",
      symbol: "$",
      priceMonth: "$3.46",
      priceYear: "$34.99",
      monthlyAmount: "3.46",
      yearlyAmount: "34.99",
      yearlyMonthlyEquivalent: "2.92",
    };
  }

  return {
    isUS: false,
    currencyCode: "EUR",
    symbol: "€",
    priceMonth: "€4.99",
    priceYear: "€49.00",
    monthlyAmount: "2.99",
    yearlyAmount: "29.99",
    yearlyMonthlyEquivalent: "2.50",
  };
}
